const IMAGE_EXTENSION = /\.(jpe?g|png|gif|webp|bmp|svg|heic|heif|avif|tiff?)$/i;

// Whether an attachment should render as an inline image. mime_type is nullable
// at runtime (SMS/MMS and migrated chat attachments can arrive without one), so
// fall back to the filename extension — otherwise a real image with a null
// mime_type renders as an ugly download card instead of a thumbnail.
export const isImageAttachment = (att: {
  mime_type: string | null;
  filename: string;
}): boolean =>
  Boolean(att.mime_type?.startsWith("image/")) ||
  IMAGE_EXTENSION.test(att.filename);
